/**
 * Test data factories for mobile-skeleton — keep DTO shapes aligned with @kiraah-shared/common.
 */
import { LvfAppPlatform, LvfAuthenticationStatus, toGuid } from "@kiraah-shared/common";
import type { MobileAuthResult } from "../models/mobile-auth.models";
import type { IdentityProfilData, TenantAppMobileSummary } from "../models/mobile-profile.models";

export function createMockIdentityProfile(
  overrides: Partial<IdentityProfilData> = {}
): IdentityProfilData {
  const appUid = "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee";
  return {
    TenantAppUid: toGuid(appUid),
    ShouldChangePassword: false,
    Applications: [],
    ...overrides,
  } as IdentityProfilData;
}

export function createMockAuthResult(overrides: Partial<MobileAuthResult> = {}): MobileAuthResult {
  return {
    Status: LvfAuthenticationStatus.SUCCESS,
    Tokens: {
      AccessToken: "test-access-token",
      RefreshToken: "test-refresh-token",
      ExpiresInSeconds: 3600,
    },
    ProfilData: createMockIdentityProfile() as unknown as MobileAuthResult["ProfilData"],
    ...overrides,
  };
}

export function createMockTenantAppSummary(
  overrides: Partial<TenantAppMobileSummary> = {}
): TenantAppMobileSummary {
  return {
    Uid: toGuid("aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"),
    Code: "academy-mobile",
    Name: "E-Learning",
    Icon: "school",
    Order: 1,
    Platform: LvfAppPlatform.MOBILE,
    Menus: [],
    ...overrides,
  };
}

